import axios from 'axios';

// API CALL CODE HERE

const CheckWanIpReachableStatusApiCall = async(ispWanId, setWanIpLanStatus, setGotWanIpLanStatus, setWanIpReachableMessage, setContinueDgLanStatus, setDetailWanIpReachableMessage, setRcaWanIpReachableMessage) =>  {
  const baseUrl = `${process.env.REACT_APP_API_SERVER_URL}/check_wan_ip_configuration.php`;

  const payload = JSON.stringify({
    "auth_token": localStorage.getItem("auth_token"),
    "client_id":localStorage.getItem("cust_id"),
    "isp_wan_id": ispWanId
  });

  return axios.post(baseUrl, payload).then((response)=>{
    // console.log(response.data)
    if(response.data.code === 1){
        setWanIpLanStatus(true)
        setContinueDgLanStatus(true)
    }
    else
    {
        setWanIpLanStatus(false)
        setContinueDgLanStatus(false)
    }
    setGotWanIpLanStatus(true)
    setWanIpReachableMessage(response.data.message)
    setDetailWanIpReachableMessage(response.data.detailed_message)
    setRcaWanIpReachableMessage(response.data.rca_message)
  })
}

export default CheckWanIpReachableStatusApiCall;
